'use client';

import { atom } from 'jotai';
import type { BuyerTipKind } from './types';

type BuyerTipSession = {
    initialShown: boolean;
    scrollShown: boolean;
};

export const buyerTipSessionAtom = atom<BuyerTipSession>({
    initialShown: false,
    scrollShown: false,
});

export const buyerInitialTipShownAtom = atom(get => get(buyerTipSessionAtom).initialShown);
export const buyerScrollTipShownAtom = atom(get => get(buyerTipSessionAtom).scrollShown);

export const markBuyerTipShownAtom = atom(null, (_get, set, kind: Exclude<BuyerTipKind, null>) => {
    set(buyerTipSessionAtom, prev => {
        if (kind === 'initial') return prev.initialShown ? prev : { ...prev, initialShown: true };
        if (kind === 'scroll') return prev.scrollShown ? prev : { ...prev, scrollShown: true };
        return prev;
    });
});
